import React, { useEffect, useState } from 'react'; 
import styles from './../../Assets/CSS/Listing.module.css';
import cardStyles from './../../Assets/CSS/Card.module.css';
import modalStyles from './../../Assets/CSS/Modal.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css'; 
import engineerbanner from './../../Assets/Images/engineerBanner.jpg';
import dummyImg from './../../Assets/Images/image-dummy.png'; 
import { IoIosArrowForward, IoIosStarOutline } from 'react-icons/io';
import { IoFilterSharp } from 'react-icons/io5';
import { IoIosStar } from 'react-icons/io';
import { GrLocation } from 'react-icons/gr';
import { GreenButton, YellowButton, BlueButton } from './../../Components/Button';
import { IoCall } from 'react-icons/io5';
import { ImStatsBars } from 'react-icons/im';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
        
function Listing() { 
    const { ssc_slug } = useParams();       
    const navigate = useNavigate();  
    const current_location = useLocation(); 
    const accessToken = localStorage.getItem('accessToken');  
    const location = localStorage.getItem('location'); 
    const [isLoading, setIsLoading] = useState(false);
    const [listing, setListing] = useState([]);
    function onGetData() {
        setIsLoading(true);
        axios.get(`${BASE_URL}/listing/${ssc_slug}/${location}`, {
            headers: {  
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setListing(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }
    useEffect(() => {
        document.title = 'Infomart | Listing';
        onGetData();
    }, []);
    const onDetails = (u_id) => {
        navigate(`/listing-details/${u_id}`); 
    }   
    const [enquiry, setEnquiry] = useState(false);  
    const handleEnquiry = (id) => { 
        if (accessToken) { 
            setEnquiry(true);  
            localStorage.setItem('listingId', id); 
        } else {  
            localStorage.setItem('currentLocation', current_location.pathname);   
            navigate('/user/login'); 
        }  
    }  
    const handleCall = (phone) => { 
        if (accessToken) {  
            window.location.href = `tel:${phone}`; 
        } else {   
            localStorage.setItem('currentLocation', current_location.pathname);    
            navigate('/user/login'); 
        }   
    }  
    const onClose = () => {
        setEnquiry(false);
        localStorage.removeItem('listingId'); 
    }  
    const [isEnquiryLoading, setIsEnquiryLoading] = useState(false);  
    const [subject, setSubject] = useState('');  
    const [message, setMessage] = useState('');  
    const handleSendEnquiry = async () => {
        setIsEnquiryLoading(true);
        const listing_id = localStorage.getItem('listingId');
        await axios.post(`${BASE_URL}/user/listing/enquiry`, {listing_id, subject, message}, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }   
        }).then((res) => { 
            setEnquiry(false); 
            setSubject(''); 
            setMessage(''); 
            localStorage.removeItem('listingId'); 
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsEnquiryLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsEnquiryLoading(false);
        });  
    }    
    const [selectedFilter, setSelectedFilter] = useState(''); 
    const handleFilterClick = (filterType) => {
        setSelectedFilter(filterType);
        if (filterType === 'rating') {
            setListing((prevListing) => {
                return [...prevListing].sort((a, b) => {
                    const avgRatingA = a.review ? a.review.reduce((acc, review) => acc + review.rating, 0) / a.review.length : 0;
                    const avgRatingB = b.review ? b.review.reduce((acc, review) => acc + review.rating, 0) / b.review.length : 0;
                    return avgRatingB - avgRatingA;  
                });
            });
        } else if (filterType === 'enquiry') {
            setListing((prevListing) => {
                return [...prevListing].sort((a, b) => (b.enquiry ? b.enquiry.length : 0) - (a.enquiry ? a.enquiry.length : 0)); 
            }); 
        }
    }; 
    const clearFilter = () => {
        onGetData(); 
        setSelectedFilter(''); 
    }
    return (
        <div className="app"> 
            {enquiry ? 
                <div className={modalStyles.enquiryModalContainer}> 
                    <div className={modalStyles.closeBtn} onClick={onClose}>&times;</div>
                    <div className={modalStyles.innerEnquiryContainer}> 
                        <div className={modalStyles.form}> 
                            <h4 className="mb-2">Enquire Now</h4>
                            <div className={modalStyles.col}>
                                <h6 className="mb-0">Subject</h6>
                                <input type="text" className={inputStyles.input} value={subject} placeholder="Enter enquiry subject" onChange={e => setSubject(e.target.value)} />
                            </div>  
                            <div className={modalStyles.col}>
                                <h6 className="mb-0">Message</h6>
                                <textarea className={inputStyles.textarea} value={message} placeholder="Enter your enquiry here.." onChange={e => setMessage(e.target.value)} />
                            </div>   
                            <BlueButton title={isEnquiryLoading ? "Loading..." : "Send Enquiry"} onClick={() => handleSendEnquiry()} />
                        </div>     
                        <div className={modalStyles.description}>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">Your requirement is sent to the selected relevant businesses</span>
                            </div>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">Businesses compete with each other to get you the Best Deal</span>
                            </div>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">You choose whichever suits you best</span>
                            </div>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">Contact info sent to you by SMS/Email</span>
                            </div>
                        </div>
                    </div> 
                </div>
            : null }  
            <div className="outlet">
                <div className={styles.mainWrapper}>
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    :
                        <div className={styles.engineerListingPageContainer}>
                            <div className={styles.bannerContainer}>
                                <img src={engineerbanner} className={styles.banner} />
                            </div>
                            <div className={styles.engineerListingMain}>
                                <div className={styles.breadCrumb}>
                                    <span>{location} <IoIosArrowForward /></span>
                                    <span className="ms-1">{listing[0]?.category.name} in {location} <IoIosArrowForward /></span>
                                    <span className="ms-1">{listing.length}+ Listings</span> 
                                </div>    
                                <div className={styles.filterSection}>
                                    <div className={styles.filterLeft}>
                                        <div className={styles.dropdownContainer}><b>Sort By:</b></div> 
                                        <div className={`${styles.filterItemBtn} ${selectedFilter === 'rating' ? styles.active : ''}`} onClick={() => handleFilterClick('rating')}>Rating</div>
                                        <div className={`${styles.filterItemBtn} ${selectedFilter === 'enquiry' ? styles.active : ''}`} onClick={() => handleFilterClick('enquiry')}>Enquiry</div>
                                    </div>  
                                    <div className={styles.filterItemBtn} onClick={clearFilter}><IoFilterSharp /> Clear Filter</div>
                                </div>    
                                <React.Fragment>
                                    {listing && listing.length > 0 ? (
                                        listing.map((data, i) => {
                                            const averageRating = data.review && data.review.length > 0 ? data.review.reduce((acc, review) => acc + review.rating, 0) / data.review.length : 0;  
                                            const roundedRating = Math.round(averageRating); 
                                            return (
                                                <div className={cardStyles.cardContainer} key={i}>
                                                    <div className={cardStyles.leftSection}>
                                                        <div className={cardStyles.imgSection}>
                                                            <img src={data.image[0]?.image ? BASE_FILE_URL + data.image[0]?.image : dummyImg} className={cardStyles.img} />
                                                            <div className={cardStyles.subImages}> 
                                                                {data.image?.map((data, i) => (
                                                                    <img src={BASE_FILE_URL + data.image} className={cardStyles.img} key={i} />
                                                                ))}     
                                                            </div> 
                                                        </div> 
                                                        <div className={cardStyles.detailSection}>
                                                            <div className={cardStyles.top} onClick={() => onDetails(data.u_id)}>
                                                                <h3 className="mb-0">{data.name}</h3>  
                                                                <div className={cardStyles.stars}>
                                                                    {[0, 1, 2, 3, 4].map((item, index) => (
                                                                        index < roundedRating ? <IoIosStar color="#ffea1d" key={index} /> : <IoIosStarOutline color="#ffea1d" key={index} />
                                                                    ))}   
                                                                </div> 
                                                                <span>{data.review?.length ?? 0} Reviews</span>
                                                            </div>  
                                                            <div className="text-muted">
                                                                {data.description && data.description.length > 150 
                                                                    ? data.description.substring(0, 150) + '...' 
                                                                    : data.description
                                                                }
                                                            </div> 
                                                            <div className={cardStyles.location}> 
                                                                <GrLocation size={25} /> 
                                                                <div>{data.house_no}, {data.road_name}, {data.district}, {data.state}, {data.pincode}</div>
                                                            </div> 
                                                            <div className={cardStyles.extraDetails}>
                                                                <React.Fragment>
                                                                    <h6 className={cardStyles.tag}>{data.sub_category?.name}</h6>
                                                                    <div className={cardStyles.dot}></div> 
                                                                </React.Fragment> 
                                                                <React.Fragment>
                                                                    <h6 className={cardStyles.tag}>{data.sub_sub_category?.name}</h6> 
                                                                </React.Fragment>
                                                            </div>
                                                            <div className={cardStyles.buttons}>
                                                                <GreenButton title="Call Now" onClick={() => handleCall(data.phone)} leftIcon={<IoCall />} />
                                                                <YellowButton title="Send Enquiry" onClick={() => handleEnquiry(data.id)} />
                                                            </div>  
                                                        </div> 
                                                    </div>  
                                                    <div className={cardStyles.divider}></div>
                                                    <div className={cardStyles.rightSection}>
                                                        <ImStatsBars color="#969696" size={56} />
                                                        <div className="text-muted">{data.enquiry?.length ?? 0} people recently enquired</div>
                                                    </div> 
                                                </div>
                                            ); 
                                        })    
                                    ) : (
                                        <h5 className="text-center mt-5">No data available.</h5>
                                    )}
                                </React.Fragment>
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default Listing;            